import "./App.css";
import Body from "./components/Body";

function App() {
  return (
    <div className="">
      <Body />
    </div>
  );
}

export default App;
